import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyDy2ulBhpYpin0MRh-s1Scrl2WWzX5LI5g',
  authDomain: 'bayerauth-9c24f.firebaseapp.com',
  projectId: 'bayerauth-9c24f',
  storageBucket: 'bayerauth-9c24f.firebasestorage.app',
  messagingSenderId: '425153489170',
  appId: '1:425153489170:web:2afd9adf61660218f62bcb',
  measurementId: 'G-37H2TVMCB9',
};

export const firebaseApp = initializeApp(firebaseConfig);
